import React from "react";
import {Global, ThemeProvider} from "@emotion/react";
import {Brands, themes} from "./theme";

import {globalFonts} from "./globalFonts";
import {globalReset} from "./globalReset";
import {FontTracker} from "./FontTracker";

type StitchStyleProviderProps = {
  /**
   * Sets the loaded brand theme
   */
  brand: Brands;
  children?: React.ReactNode;
};

export function StitchStyleProviderBase({
  brand,
  children,
}: StitchStyleProviderProps): JSX.Element {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ThemeProvider theme={themes[brand] as any}>{children}</ThemeProvider>
  );
}

export function StitchStyleProvider({
  brand,
  children,
}: StitchStyleProviderProps): JSX.Element {
  return (
    <StitchStyleProviderBase brand={brand}>
      <Global styles={[globalFonts(brand), globalReset(themes[brand])]} />
      {children}
      <FontTracker brand={brand} />
    </StitchStyleProviderBase>
  );
}
